import CustomProvider from 'components/CustomProvider';

import LegacyMap404Header from 'components/errors/LegacyMap404Header';

const LegacyMap404 = () => (
  <CustomProvider>
    <LegacyMap404Header />
  </CustomProvider>
);

export default LegacyMap404;
